import { createStore, atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

type UserData = {
  Token: string;
  UserName: string;
  Id: string; // Admin user ID
  expiryDate: string;
  Role: string;
  AdminUserHasChangePassword?: boolean;
  FirstName: string;
  justLogged?: boolean;
  RoleNames: string[];
  PathName: string[];
  Permissions: string[];
};

type ActivePeriod = {
  Id: number;
  Name: string;
};

const appStore = createStore();

// Persist user state across reloads using localStorage
export const userAtom = atomWithStorage<UserData | null>('user', null);
export const activePeriod = atom<ActivePeriod | null>(null);

// Set initial values for non-persistent store only if needed
appStore.set(activePeriod, {
  Id: 1,
  Name: 'March',
});


export default appStore;





// import {createStore,atom} from 'jotai';

// type UserData = {
//     Token: string;
//     UserName: string;
//     Id: string;
//     expiryDate: string;
//     Role: string;
//     AdminUserHasChangePassword?:boolean;
//     FirstName:string;
//     justLogged?:boolean;
//     RoleNames:string[];
//     PathName:string[],
//     Permissions:string[],  
//   }
// type ActivePeriod ={
//   Id:number;
//   Name:string;
// }
// const appStore = createStore();


// export const userAtom = atom<UserData |null>(null);
// export const activePeriod = atom<ActivePeriod | null>(null);

// appStore.set(userAtom,{
//     AdminUserHasChangePassword:false,
//     FirstName:'',
//     Id:'',
//     Role:'',
//     Token:'',
//     UserName:'',
//     expiryDate:"",
//     justLogged:false,
//     RoleNames:[],
//     Permissions:[],
//     PathName:[]
//   }
// )
// appStore.set(activePeriod,{
//   Id:1,
//   Name:'March'
// })


// export default appStore;

